import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import './Modal.scss';

const rootElement = __CLIENT__ && document.body;

const Modal = ({ show, skin, children, onClick }) => {
	const wrapperRef = useRef(null);
	const [hasFocus, setHasFocus] = useState(false);
	if (wrapperRef.current === null && __CLIENT__) {
		const portalElement = __CLIENT__ && document.createElement('div');
		wrapperRef.current = portalElement;
	}

	function listenForEsc(e) {
		if (e.keyCode === 27) {
			this.hide();
		}
	}

	useEffect(() => {
		const handleTabKey = (event) => {
			const firstFocusableElement = wrapperRef.current.querySelector(
				'input, button, [href], [tabindex]:not([tabindex="-1"])'
			);
			if ((event.key === 'Tab' || event.keyCode === 9) && !hasFocus) {
				firstFocusableElement.focus();
				setHasFocus(true);
			}
		};

		if (show) {
			rootElement.appendChild(wrapperRef.current);
			rootElement.classList.add('body-modal__show');
			wrapperRef.current.className = `modal modal__show ${skin ? skin : ''}`;
			if (onClick) wrapperRef.current.onclick = onClick;
			document.addEventListener('keydown', handleTabKey);
		} else {
			removeModal();
		}

		return removeModal;

		function removeModal() {
			rootElement.classList.remove('body-modal__show');
			wrapperRef.current.className = 'modal';
			document.removeEventListener('keydown', listenForEsc, true);
			document.removeEventListener('keydown', handleTabKey);
		}
	}, [onClick, show, skin, hasFocus]);

	useEffect(() => {
		return () => {
			if (rootElement.contains(wrapperRef.current)) {
				rootElement.removeChild(wrapperRef.current);
			}
		};
	}, []);

	return show ? createPortal(children, wrapperRef.current) : null;
};

Modal.propTypes = {
	show: PropTypes.bool.isRequired,
	skin: PropTypes.string,
};

export default Modal;
